import angular from 'angular'

import playerFactory from 'components/player-factory'

import component from './player-preview.component'

export default angular.module('player-preview', [
  playerFactory
])
  .directive('playerPreview', component)
  .name
